import {VATItem} from '../../domain/vat-item';

export class VATService {
  private VAT_ITEMS: Array<VATItem> = [{
    'data-id': '1',
    'data-value': '24.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '24%'
  }, {
    'data-id': '2',
    'data-value': '23.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '23%'
  }, {
    'data-id': '3',
    'data-value': '22.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '22%'
  }, {
    'data-id': '4',
    'data-value': '21.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '21%'
  }, {
    'data-id': '5',
    'data-value': '20.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '20%'
  }, {
    'data-id': '6',
    'data-value': '10.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '10%'
  }, {
    'data-id': '7',
    'data-value': '8.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '8%'
  }, {
    'data-id': '8',
    'data-value': '5.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '5%'
  }, {
    'data-id': '9',
    'data-value': '4.00',
    'data-natura': '',
    'data-riferimento': '',
    'label': '4%'
  }, {
    'data-id': '10',
    'data-value': '0.00',
    'data-natura': 'N1',
    'data-riferimento': 'Escluse ex. art. 15 del D.P.R. 633/1972',
    'label': '0% - N1 - Escluse ex. art. 15 del D.P.R. 633/1972'
  }, {
    'data-id': '11',
    'data-value': '0.00',
    'data-natura': 'N2.1',
    'data-riferimento': 'Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72',
    'label': '0% - N2.1 - Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72'
  }, {
    'data-id': '12',
    'data-value': '0.00',
    'data-natura': 'N2.2',
    'data-riferimento': 'Non soggette - altri casi',
    'label': '0% - N2.2 - Non soggette - altri casi'
  }, {
    'data-id': '13',
    'data-value': '0.00',
    'data-natura': 'N3.1',
    'data-riferimento': 'Non Imponibili - esportazioni',
    'label': '0% - N3.1 - Non Imponibili - esportazioni'
  }, {
    'data-id': '14',
    'data-value': '0.00',
    'data-natura': 'N3.2',
    'data-riferimento': 'Non Imponibili - cessioni intracomunitarie',
    'label': '0% - N3.2 - Non Imponibili - cessioni intracomunitarie'
  }, {
    'data-id': '15',
    'data-value': '0.00',
    'data-natura': 'N3.3',
    'data-riferimento': 'Non Imponibili - cessioni verso San Marino',
    'label': '0% - N3.3 - Non Imponibili - cessioni verso San Marino'
  }, {
    'data-id': '16',
    'data-value': '0.00',
    'data-natura': 'N3.4',
    'data-riferimento': 'Non Imponibili - operazioni assimilate alle cessioni all\'esportazione',
    'label': '0% - N3.4 - Non Imponibili - operazioni assimilate alle cessioni all\'esportazione'
  }, {
    'data-id': '17',
    'data-value': '0.00',
    'data-natura': 'N3.5',
    'data-riferimento': 'Non Imponibili - a seguito di dichiarazioni d\'intento',
    'label': '0% - N3.5 - Non Imponibili - a seguito di dichiarazioni d\'intento'
  }, {
    'data-id': '18',
    'data-value': '0.00',
    'data-natura': 'N3.6',
    'data-riferimento': 'Non Imponibili - altre operazioni che non concorrono alla formazione del plafond',
    'label': '0% - N3.6 - Non Imponibili - altre operazioni che non concorrono alla formazione del plafond'
  }, {
    'data-id': '19',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Esenti',
    'label': '0% - N4 - Esenti'
  }, {
    'data-id': '20',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Escluso Art.10',
    'label': '0% - N4 - Escluso Art.10'
  }, {
    'data-id': '21',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Escluso Art.10 comma 1',
    'label': '0% - N4 - Escluso Art.10 comma 1'
  }, {
    'data-id': '22',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Escluso Art.10 comma 20',
    'label': '0% - N4 - Escluso Art.10 comma 20'
  }, {
    'data-id': '23',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Escluso Art.10 n.27 D.P.R 633/72',
    'label': '0% - N4 - Escluso Art.10 n.27 D.P.R 633/72'
  }, {
    'data-id': '24',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Non Imp. Art.10 n.18 DPR 633/72',
    'label': '0% - N4 - Non Imp. Art.10 n.18 DPR 633/72'
  }, {
    'data-id': '25',
    'data-value': '0.00',
    'data-natura': 'N4',
    'data-riferimento': 'Esente Art.10 DPR 633/72',
    'label': '0% - N4 - Esente Art.10 DPR 633/72'
  }, {
    'data-id': '26',
    'data-value': '0.00',
    'data-natura': 'N5',
    'data-riferimento': 'Escluso Art.74 ter D.P.R. 633/72',
    'label': '0% - N5 - Escluso Art.74 ter D.P.R. 633/72'
  }, {
    'data-id': '27',
    'data-value': '0.00',
    'data-natura': 'N5',
    'data-riferimento': 'Regime del margine art.36 41/95',
    'label': '0% - N5 - Regime del margine art.36 41/95'
  }, {
    'data-id': '28',
    'data-value': '0.00',
    'data-natura': 'N6.1',
    'data-riferimento': 'Inversione contabile - cessione di rottami e altri materiali di recupero',
    'label': '0% - N6.1 - Inversione contabile - cessione di rottami e altri materiali di recupero'
  }, {
    'data-id': '29',
    'data-value': '0.00',
    'data-natura': 'N6.2',
    'data-riferimento': 'Inversione contabile - cessione di oro e argento ai sensi della legge 7/2000 nonché di oreficeria usata ad OPO',
    'label': '0% - N6.2 - Inversione contabile - cessione di oro e argento ai sensi della legge 7/2000 nonché di oreficeria usata ad OPO'
  }, {
    'data-id': '30',
    'data-value': '0.00',
    'data-natura': 'N6.3',
    'data-riferimento': 'Inversione contabile - subappalto nel settore edile',
    'label': '0% - N6.3 - Inversione contabile - subappalto nel settore edile'
  }, {
    'data-id': '31',
    'data-value': '0.00',
    'data-natura': 'N6.4',
    'data-riferimento': 'Inversione contabile - cessione di fabbricati',
    'label': '0% - N6.4 - Inversione contabile - cessione di fabbricati'
  }, {
    'data-id': '32',
    'data-value': '0.00',
    'data-natura': 'N6.5',
    'data-riferimento': 'Inversione contabile - cessione di telefoni cellulari',
    'label': '0% - N6.5 - Inversione contabile - cessione di telefoni cellulari'
  }, {
    'data-id': '33',
    'data-value': '0.00',
    'data-natura': 'N6.6',
    'data-riferimento': 'Inversione contabile - cessione di prodotti elettronici',
    'label': '0% - N6.6 - Inversione contabile - cessione di prodotti elettronici'
  }, {
    'data-id': '34',
    'data-value': '0.00',
    'data-natura': 'N6.7',
    'data-riferimento': 'Inversione contabile - prestazioni comparto edile e settori connessi',
    'label': '0% - N6.7 - Inversione contabile - prestazioni comparto edile e settori connessi'
  }, {
    'data-id': '35',
    'data-value': '0.00',
    'data-natura': 'N6.8',
    'data-riferimento': 'Inversione contabile - operazioni settore energetico',
    'label': '0% - N6.8 - Inversione contabile - operazioni settore energetico'
  }, {
    'data-id': '36',
    'data-value': '0.00',
    'data-natura': 'N6.9',
    'data-riferimento': 'Inversione contabile - altri casi',
    'label': '0% - N6.9 - Inversione contabile - altri casi'
  }, {
    'data-id': '37',
    'data-value': '0.00',
    'data-natura': 'N7',
    'data-riferimento': 'IVA assolta in altro stato UE (prestazione di servizi di telecomunicazioni, tele-radiodiffusione ed elettronici ex art. 7-octies lett. a, b, art. 74-sexies DPR 633/72)',
    'label': '0% - N7 - IVA assolta in altro stato UE (prestazione di servizi di telecomunicazioni, tele-radiodiffusione ed elettronici ex art. 7-octies lett. a, b, art. 74-sexies DPR 633/72)'
  }];

  getItems(): Array<VATItem> {
    return this.VAT_ITEMS;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/data/vat.service.ts